export const PAYMENT_METHOD_STATUS = {
  active: 'ACTIVE',
  inactive: 'INACTIVE'
}

export const PAYMENT_METHOD_TYPE = {
  creditCard: 'CREDIT_CARD',
  blikRecurring: 'BLIK_RECURRING'
}
